// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"704a36ee","65":"e06f3ff2","157":"4dd3093e","287":"ee90ed4d","340":"7d0e63dc","453":"fe0685ae","490":"825c6eb3","517":"b51c5695","523":"c1a6a0c9","598":"57557ab9","702":"3fbb5c3c","790":"06162e7c","859":"2d03ca23","941":"ff8cba83","959":"b6a9e644"}[chunkId] + ".chunk.js";
};